export const getOptionsByStatus = (status) => {
  const mapConditions = new Map([
    ["CANCELED", { text: "Cancelado", color: "error", icon: "error" }],
    ["ACTIVE", { text: "Ativo", color: "primary", icon: "check_circle" }],
    [
      "SUSPENDED",
      { text: "Pagamento não efetuado", color: "warning", icon: "warning" },
    ],
    ["EXPIRED", { text: "Expirada", color: "warning", icon: "warning" }],
    [
      "TRIALING",
      { text: "Periodo teste", color: "info", icon: "hourglass_empty" },
    ],
    ["UNKNOWN", { text: "Desconhecido", color: "grey", icon: "help" }],
  ]);
  return mapConditions.get(status) || {};
};
